





















import { Component, Mixins } from 'vue-property-decorator';
import ActivityIntegrationMixin from '@/mixins/vue/ActivityIntegrationMixin';
import { MUTATE_SHOW_WELCOME_MESSAGE } from '@/store/modules/interface';
import OrderMixin from '@/mixins/vue/OrderMixin';
import Tabs from '@/components/global/Tabs.vue';

@Component({
    components: {
        Tabs,
    },
})
export default class Products extends Mixins(ActivityIntegrationMixin, OrderMixin) {
    public tabItems = [
        {
            label: 'All Products',
            name: 'all-products',
        },
        {
            label: 'Unclaimed',
            name: 'unclaimed-products',
        },
        {
            label: 'Claimed',
            name: 'claimed-products',
        },
        {
            label: 'Transferred',
            name: 'transferred-products',
        },
    ];

    public created() {
        this.integrateActivitesFromBackEndToLocalStorage().catch((err) => {
            console.error(err);
        });

        this.integrateTotalActivitesDailyFromBackEndToLocalStorage().catch((err) => {
            console.error(err);
        });

        this.integrateTotalActivitesMonthlyFromBackEndToLocalStorage().catch((err) => {
            console.error(err);
        });

        this.integrateTotalActivitesYearlyFromBackEndToLocalStorage().catch((err) => {
            console.error(err);
        });
        this.integrateOrdersFromBackEndToLocalStorage().catch((err) => {
            console.error(err);
        });
    }
}
